import { useSyncExternalStore } from 'react';

export type CommandPaletteBoardContext = {
  boardId?: string;
  onCreateCard?: () => void;
  onCreateColumn?: () => void;
  onToggleActivity?: () => void;
};

let currentContext: CommandPaletteBoardContext = {};
const listeners = new Set<() => void>();

const emit = () => {
  listeners.forEach((listener) => listener());
};

export const setCommandPaletteBoardContext = (context: CommandPaletteBoardContext) => {
  currentContext = context;
  emit();
};

export const clearCommandPaletteBoardContext = (boardId?: string) => {
  if (!boardId || currentContext.boardId === boardId) {
    currentContext = {};
    emit();
  }
};

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

const getSnapshot = () => currentContext;

export const useCommandPaletteBoardContext = () => useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
